/* eslint-disable no-throw-literal */
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import clubAPI from "../api/clubAPI";
import "../App.scss";

import swalDialog from "../helpers/swalErrorPopup";
import FreeFitDefaultImg from "../img/freefit_default.png";
import HistoryDefImg from "../img/history_def_img.png";
import CancelWhite from "../img/svg/cancel_white.svg";
import ConfirmPopup from "../shared/confirmPopup";
import ImageWithFallback from "../shared/imageWithFallback";
import PopupWithSmile from "../shared/popupWithSmile";
import { PoweredBy } from "../shared/PoweredBy";
import { selectPastOrdersData, updateAllFutureOrders, updateAllPastOrders } from "../store/appParamSlice";

import { headerCustomDisplaying, headerDisplaying, isLoadChanger, setCustomHeaderText } from "../store/mainSlice";
import {
  checkCanPurchasePass,
  fetchMultipleEntryPasses,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import { isPartnerClalit, selectIsOrthodox } from "../store/partnerStore";
import { convertDateFormat } from "../utils/formatter";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: "100vh", paddingBottom: "20px" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }} style={{ padding: "8px" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const OrderHistory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isClalit = useSelector(isPartnerClalit);
  const isOrthodox = useSelector(selectIsOrthodox);
  const [value, setValue] = useState(1);
  const [isOpenPopupWithSmile, setOpenPopupWithSmile] = useState(false);
  const [isOpenConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState();
  const [detailedClubParams, setDetailedClubParams] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const userParams = useSelector((state) => state.userSlice.userData);
  const futureOrdersData = useSelector((state) => state.appParamSlice.futureOrdersData);
  const pastOrdersData = useSelector(selectPastOrdersData);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const activeMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getWebFullData({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        const clubParam = JSON.parse(param.data.Data);
        setDetailedClubParams(clubParam?.ClubList);
        dispatch(isLoadChanger(false));
        if (param.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }
      } catch (err) {
        swalDialog(err);
      }
    };
    fetch();
    dispatch(headerDisplaying(true));
    dispatch(headerCustomDisplaying(true));
    dispatch(setCustomHeaderText(t("MY_ORDERS")));

    return () => {
      dispatch(headerDisplaying(true));
      dispatch(headerCustomDisplaying(false));
      dispatch(setCustomHeaderText(""));
    };
  }, []);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getWebClubOrders({
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (param.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }

        dispatch(updateAllFutureOrders([...JSON.parse(param.data.Data)]));
        const oldParam = await clubAPI.getWebClientEntriesHistory({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (oldParam.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: oldParam.data.Error,
            mess: oldParam.data.Message,
          };
        }
        dispatch(updateAllPastOrders([...JSON.parse(oldParam.data.Data)]));
        dispatch(isLoadChanger(false));
      } catch (err) {
        dispatch(isLoadChanger(false));
        swalDialog(err);
      }
    };
    if (userParams && Object.keys(userParams).length > 0) {
      fetch();
    }
  }, [userParams, refresh]);

  const handleCancelOrder = async (orderId) => {
    setOpenPopupWithSmile(false);
    try {
      dispatch(isLoadChanger(true));
      const param = await clubAPI.cancelWebClubOrder({
        clubOrderNum: orderId,
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });
      setRefresh((prev) => !prev);
      if (param.data.Error !== 0) {
        throw {
          code: param.data.Error,
          mess: param.data.Message,
        };
      }
      if (param.data.Error === 0) {
        if (isClalit) {
          const params = {
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          };
          dispatch(fetchMultipleEntryPasses(params));
          dispatch(
            checkCanPurchasePass({
              token: mainUserParams.Token,
              id: mainUserParams.ID,
              phone: mainUserParams.Phone,
            }),
          );

          setOpenConfirmPopup(true);
        }
      }

      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  return (
    <div className="order-history-main-wrapper">
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
          className="order-history-tabs"
          TabIndicatorProps={{
            style: {
              backgroundColor: "var(--darkblue)",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              color: "#7C7570",
              borderBottom: "1px solid #E9E9E7 !important",
            },
            "& .Mui-selected": {
              color: "var(--darkblue) !important",
              fontWeight: 700,
            },
          }}
        >
          <Tab label={t("ORDER_HISTORY")} className="order-history-tab" {...a11yProps(0)} />
          <Tab label={t("UPCOMING_ORDERS")} className="order-history-tab" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <CustomTabPanel value={value} index={0}>
          <div className="history-cards">
            {pastOrdersData.map((el, i) => (
              <div className="history-card" key={i}>
                <div className="history-card-content-wrapper">
                  <div className="history-card-content-wrapper-row">
                    {el.IsCancelled && !isClalit && <div className="history-card-cancel">{t("CANCELLED_BADGE")}</div>}

                    <div className="history-card-content-wrapper-inner">
                      <p style={{ marginTop: "4px" }}>{el.SupplyDate.split(" ").reverse().join(` ${"\u2022"} `)}</p>
                      <p style={{ fontWeight: 700, marginTop: "5px" }}>{el?.ClubName}</p>
                      <p>{el?.ClubTypeName}</p>
                      <div className="history-card-details">
                        <p>{el?.LessonName ?? ""}</p>
                        <p>{el?.CoachName ?? ""}</p>
                      </div>
                    </div>
                  </div>

                  <div className="history-card-button-and-text">
                    <button
                      className="custom-button-blue custom-button-one-line"
                      onClick={() => {
                        navigate(`/venue/${el?.ClubID}`, {
                          state: {
                            price: detailedClubParams.find((elem) => elem.RecordID === el?.ClubID)?.Price ?? el?.Price,
                            clubId: el?.ClubID,
                            clubName: el?.ClubName,
                          },
                        });
                      }}
                    >
                      {t("BOOK_AGAIN")}
                    </button>
                  </div>
                </div>
                <ImageWithFallback
                  src={isOrthodox ? FreeFitDefaultImg : el.MobClubLogoPath}
                  fallbackSrc={isClalit ? HistoryDefImg : FreeFitDefaultImg}
                  alt="Club logo"
                />
              </div>
            ))}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <div className="history-cards">
            {futureOrdersData.map((el) => (
              <div className="history-card">
                <div className="history-card-content-wrapper">
                  <div className="history-card-content-wrapper-inner">
                    <div className="history-card-time" style={{ display: "flex" }}>
                      <p>{el?.SupplyDate.split(" ")[1]}</p>
                      <p style={{ marginRight: "8px", marginLeft: "8px" }}>&#8226;</p>
                      <p>{convertDateFormat(el?.SupplyDate.split(" ")[0])}</p>
                    </div>
                    <p className="history-card-club-name">{el?.ClubName}</p>
                    <div className="history-card-details">
                      <p>{el?.LessonName ?? ""}</p>
                      <p>{el?.CoachName ?? ""}</p>
                    </div>
                  </div>

                  <div className="history-card-button-and-text">
                    {el.IsCancelAllow ? (
                      <div className="history-card-button-and-text-wrapper">
                        {isClalit ? (
                          <button
                            className="custom-button-red"
                            onClick={() => {
                              setOpenPopupWithSmile(true);
                              setSelectedOrderId(el.ID);
                            }}
                          >
                            {t("CANCEL_ORDER")}
                          </button>
                        ) : (
                          <button
                            className="cancel-button-blue"
                            onClick={() => {
                              setOpenPopupWithSmile(true);
                              setSelectedOrderId(el.ID);
                            }}
                          >
                            {t("CANCEL_ORDER")}
                            <img src={CancelWhite} alt="close" style={{ width: "12px" }} />
                          </button>
                        )}
                        {el?.CancellationTime > 0 ? (
                          <p className="history-card-button-and-text-wrapper-text">
                            {t("CANCELLATION_TIME_INFO", {
                              hours: el.CancellationTime,
                            })}
                          </p>
                        ) : (
                          <p className="history-card-button-and-text-wrapper-text">{t("CANCELLATION_TIME_NO_LIMIT")}</p>
                        )}
                      </div>
                    ) : (
                      <button className={`custom-button-disabled `} disabled={true}>
                        {t("CANCELLATION_TIME_PASSED")}
                      </button>
                    )}
                  </div>
                </div>
                <ImageWithFallback
                  src={isOrthodox ? FreeFitDefaultImg : el.ClubLogo}
                  fallbackSrc={isClalit ? HistoryDefImg : FreeFitDefaultImg}
                  alt="Club logo"
                />
              </div>
            ))}
          </div>
        </CustomTabPanel>
        {isClalit && (
          <div style={{ position: "sticky", bottom: 0 }}>
            <PoweredBy />
          </div>
        )}
      </Box>

      <PopupWithSmile
        isOpen={isOpenPopupWithSmile}
        setIsOpen={setOpenPopupWithSmile}
        headerTextTop={t("DO_YOU_WANT_TO_CANCEL")}
        headerTextBottom={t("THE_ORDER")}
        subheaderText={t("IMPORTANT")}
        bodyText={t("CANCELLATION_REFUND_INFO")}
        bodySubText={
          isClalit ? (activeMultipleEntryPass ? t("PAYMENT_MULTIPLE_ENTRY_PASS_UPDATED") : t("REFUND_TIMEFRAME")) : ""
        }
        cancelBtnText={t("ORDER_HISTORY_CLOSE")}
        confirmBtnText={t("ORDER_HISTORY_CANCEL")}
        displayCloseBtn={isClalit}
        handleSubmit={() => handleCancelOrder(selectedOrderId)}
      />
      <ConfirmPopup
        isOpen={isOpenConfirmPopup}
        setIsOpen={setOpenConfirmPopup}
        headerTextTop={t("ORDER_CANCELLED")}
        headerTextBottom={t("SUCCESSFULLY")}
        bodySubText={
          isClalit && activeMultipleEntryPass ? t("PAYMENT_MULTIPLE_ENTRY_PASS_UPDATED") : t("REFUND_TIMEFRAME")
        }
        btnText={t("CARD_DETAILS.CLOSE")}
        handleClose={() => {
          setOpenConfirmPopup(false);
        }}
      />
    </div>
  );
};

export default OrderHistory;
